export class ServerError extends Error {
  constructor(message = 'server error') {
    super(message)

    this.name = 'ServerError'
  }
}
